import React, { useEffect, useState, Fragment, useRef } from 'react';
import {
  Button,
  Dialog,
  Input,
  Form,
  Table,
  Message,
  Card,
  Pagination,
} from '@alifd/next';
import styles from './index.module.scss';
import client from '../../../../lib/feathers';
import { store as appStore } from 'ice';
const { Item } = Form;

const AccountPageSetting = (props) => {
  //功能全部資料
  const [userGroupRouteAllArr, setUserGroupRouteAllArr] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(10);
  //測試model
  useEffect(() => {
    const fetchPosts = async () => {
      function ordersort(a, b) {
        return a.order > b.order ? 1 : -1;
      }

      client
        .service('userGroupRouteAll')
        .find({})
        .then((result) => {
          setUserGroupRouteAllArr(result.data.sort(ordersort));
        });
    };

    fetchPosts();
    // console.log(data, 'kkk');
  }, []);

  // 得到當前 userGroupRouteAllArr
  // const indexOfLastPost = currentPage * postsPerPage;
  // const indexOfFirstPost = indexOfLastPost - postsPerPage;
  // const currentPosts = userGroupRouteAllArr.slice(
  //   indexOfFirstPost,
  //   indexOfLastPost
  // );
  // console.log(currentPosts)

  //建立社區開放功能
  const userGroupRoute = client.service('userGroupRoute');
  const [userGroupRouteArr, setUserGroupRouteArr] = useState([]);
  // const [onSelect, setOnSelect] = useState({ selected: false, records: [] });
  // const [onSelect, setOnSelect] = useState([]);
  // console.log(onSelect)
  // const [onSelectAll, setOnSelectAll] = useState({ selected: false, records: [] });
  const [onChange, setOnChange] = useState([]);
  // console.log(onChange)

  //userGroupRoute table

  //userGroupRoute查詢
  function userGroupRouteFind(para) {
    return new Promise((resolve, reject) => {
      try {
        userGroupRoute.find({ query: para }).then((result) => {
          resolve(result && result.data ? result.data : []);
        });
      } catch (error) {
        reject(error);
      }
    });
  }
  //userGroupRoute新增
  function userGroupRouteCreate(obj) {
    return new Promise((resolve, reject) => {
      try {
        userGroupRoute.create(obj).then((result) => {
          resolve(result);
        });
      } catch (error) {
        reject(error);
      }
    });
  }

  //userGroupRoute更新
  function userGroupRouteUpdate(id, obj) {
    return new Promise((resolve, reject) => {
      // console.log(id, obj, params)
      userGroupRoute
        .patch(id, obj)
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
  //userGroupRoute刪除
  function userGroupRouteRemove(id) {
    return new Promise((resolve, reject) => {
      try {
        userGroupRoute.remove(id).then((result) => {
          resolve(result);
        });
      } catch (error) {
        reject(error);
      }
    });
  }

  function ordersort(a, b) {
    return a.order > b.order ? 1 : -1;
  }
  function serverGroupRouteUpdate() {
    userGroupRouteFind({}).then((result) => {
      setUserGroupRouteArr(result.sort(ordersort));
    });
  }
  useEffect(() => {
    serverGroupRouteUpdate();
  }, []);

  return (
    <>
      <Card free>
        <Card.Content>
          <div style={{ display: 'flex' }}>
            <h2>選擇社區開放功能</h2>

            <Button
              type="secondary"
              style={{ marginLeft: '20px' }}
              onClick={() => {
                try {
                  // if (onSelectAll.records.length === 0 && onSelect.records.length===0) {
                  //   Message.warning('請勾選功能');
                  // }
                  if (onChange.length === 0) {
                    Message.warning('請勾選功能');
                  }

                  if (onChange.length > 0) {
                    userGroupRouteRemove(null, { query: {} })
                      .then((res) => {
                        console.log('==userGroupRoute delete success', res);
                        userGroupRouteCreate(onChange)
                          .then((res) => {
                            console.log(
                              '==userGroupRoute create success:',
                              res
                            );
                            serverGroupRouteUpdate();
                            Message.success('建立成功');
                          })
                          .catch((error) => {
                            console.log('==userGroupRoute create fail:', error);
                            // Message.error(`${err}`);
                          });
                      })
                      .catch((error) => {
                        console.log('==userGroupRoute delete fail:', error);
                        // Message.error(`${err}`);
                      });
                  }
                  // if (onSelectAll.records.length > 0) {

                  //   userGroupRouteAllRemove(null, { query: {} })
                  //     .then(() => {
                  //       userGroupRouteAllCreate(onSelectAll.records)
                  //     }).then(() => {
                  //       serverGroupRouteAllUpdate();
                  //       Message.success('建立成功');
                  //     });

                  // }
                  // else if (onSelect.records.length > 0) {

                  //   userGroupRouteAllRemove(null, { query: {} })
                  //     .then(() => {
                  //       userGroupRouteAllCreate(onSelect.records)
                  //     }).then(() => {
                  //       serverGroupRouteAllUpdate();
                  //       Message.success('建立成功');
                  //     });

                  // }
                } catch (err) {
                  console.log('==新增失敗', err);
                  Message.error('新增失敗');
                }
              }}
            >
              建立
            </Button>
          </div>

          <Table
            dataSource={userGroupRouteAllArr}
            primaryKey="_id"
            rowSelection={{
              // onSelect: (selected, record, records) => {
              //   console.log('onSelectSingle', selected, record, records);
              //   // setOnSelect({ selected: selected, records: records })
              //   let result= [...onSelect.concat(records)]
              //   setOnSelect();
              // },
              // onSelectAll: (selected, records) => {
              //   console.log('onSelectAll', selected, records);
              //   setOnSelectAll({ selected: selected, records: records })

              // },
              onChange: (ids, records) => {
                // console.log('onChange', records);

                // let result = [...onChange.concat(records)];
                // let val = result.filter(
                //   (item, index) => result.indexOf(item) === index
                // );
                console.log(records);
                setOnChange(records);
                // setOnChange([...new Set(result)])
              },
            }}
          >
            <Table.Column title="順序" dataIndex="order" width={100} lock='left'  />
            <Table.Column title="頁面名稱" dataIndex="name" width={250} />
            <Table.Column title="頁面路徑" dataIndex="path" width={250} />
            <Table.Column
              title="子頁面"
              width={500}
              cell={(value, index, record) => {
                return (
                  <ol>
                    {userGroupRouteAllArr[index].children.map((list, index) => {
                      return (
                        <div key={index}>
                          <li> {`子頁面名稱:${list.name}`}</li>
                          <li>{`子頁面路徑:${list.path}`}</li>
                        </div>
                      );
                    })}
                  </ol>
                );
              }}
            />
          </Table>
          <br />
          {/* <Pagination
            total={userGroupRouteAllArr.length}
            onChange={(pageNumber) => setCurrentPage(pageNumber)}
          /> */}
        </Card.Content>
      </Card>
    </>
  );
};

export default AccountPageSetting;
